<template>
  <div>
    <integratedSearchBar
      :button_display="currentUserCan('see', 'companies')"
      button_type="link"
      :button_parameter="{ name: 'companies' }"
      button_label="Companies"
      button_icon="store"
      v-bind:search.sync="search"
      search_label="Search opportunities..."
    />

    <v-data-table
      :headers="headers"
      :items="opportunities"
      :search="search"
      :pagination.sync="pagination"
      :loading="loading"
      rows-per-page-text="Opportunities per page"
    >
      <v-progress-linear
        slot="progress"
        color="blue"
        indeterminate
      ></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td>{{ fromOfferOrDemand(props.item) }}</td>
        <td>{{ props.item.name }}</td>

        <td>{{ props.item.company_type }}</td>

        <td class="pr-0">
          <opportunityCompaniesModale :opportunity="props.item" />
        </td>

        <td class="px-0">
          <v-layout row align-center justify-end>
            <v-btn
              fab
              small
              flat
              @click="redirectToSearch(props.item)"
              color="grey"
            >
              <v-icon>loop</v-icon>
            </v-btn>

            <destroyModale
              resourceName="opportunity"
              :itemId="props.item.id"
              warningText="You are going to remove this opportunity permanently"
              small
            />
          </v-layout>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import OPPORTUNITIES_INDEX from "../../graphql/opportunities/index.gql";
import opportunityCompaniesModale from "../companies/opportunityCompaniesModale";
import integratedSearchBar from "../shared/integratedSearchBar";
import { mapGetters } from "vuex";

export default {
  components: { opportunityCompaniesModale, integratedSearchBar },
  data() {
    return {
      search: "",
      searchCompanies: "",
      loading: false,
      pagination: {
        descending: true,
        rowsPerPage: 25,
        sortBy: "created_at",
      },
      headers: [
        {
          text: "From",
          align: "left",
          sortable: true,
          value: "",
          width: "1%",
        },
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "name",
        },
        {
          text: "Type",
          align: "left",
          sortable: true,
          value: "company_type",
          width: "15%",
        },
        {
          text: "Search results",
          align: "center",
          value: "search_results",
          width: "1%",
        },
        {
          text: "Actions",
          align: "right",
          sortable: false,
          width: "1%",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("companyStore", ["opportunities"]),
    ...mapGetters("commonStore", [
      "categoryOfProduct",
      "countryGroupIdsFromCountryIds",
    ]),
  },
  methods: {
    fromOfferOrDemand(item) {
      if (item.offers[0] && item.offers[0].id) return "Offer";
      if (item.demands[0] && item.demands[0].id) return "Demand";
      return "Search";
    },
    redirectToSearch(item) {
      const categoryId = item.product_ids[0]
        ? this.categoryOfProduct(item.product_ids[0])
        : null;
      const originCountryGroupIds = this.countryGroupIdsFromCountryIds(
        item.origin_country_ids
      );
      const destinationCountryGroupIds = this.countryGroupIdsFromCountryIds(
        item.destination_country_ids
      );
      const params = {
        company_type: item.company_type,
        company_status_ids: item.company_status_ids,
        origin_country_ids: item.origin_country_ids,
        destination_country_ids: item.destination_country_ids,
        origin_country_group_ids: originCountryGroupIds,
        destination_country_group_ids: destinationCountryGroupIds,
        product_category_id: categoryId,
        product_ids: item.product_ids,
        packaging_ids: item.packaging_ids,
        expanded: true,
        searchAtStart: true,
      };
      const str = Object.entries(params)
        // eslint-disable-next-line no-unused-vars
        .filter(([key, val]) => {
          return !!val && (val == true || val.length > 0);
        })
        .map(([key, val]) => `${key}=${val}`)
        .join("&");
      this.$router.push({ path: `companies?${str}` });
    },
  },
  created() {
    this.subscribe(OPPORTUNITIES_INDEX, null, "companyStore", "opportunities");
  },
  beforeDestroy() {
    this.unsubscribe("opportunities");
  },
};
</script>

<style lang="stylus" scoped>

.search {
  max-width: 300px;
}
</style>
